export default __webpack_public_path__ + "static/media/bg4_m.9a21c066.png";